import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import PageLayout from "./components/layout/PageLayout";
import HeroSection from "./components/sections/HeroSection";
import GalleryPreview from "./components/sections/GalleryPreview";
import ContextGallery from "./components/sections/ContextGallery";
import PrintsSection from "./components/sections/PrintsSection";
import ArtistSection from "./components/sections/ArtistSection";
import ContactSection from "./components/sections/ContactSection";
import FeaturedArtwork from "./components/sections/FeaturedArtwork";
import { removeAllImageProtections } from "./utils/removeImageProtection";
import Logo from "./LOGO.svg";

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading assets
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    // Desactivar la protección de imágenes para permitir edición del fondo y otras funcionalidades
    removeAllImageProtections();

    return () => {
      clearTimeout(timer);
    };
  }, []);

  // Loader animation
  if (loading) {
    return (
      <div className="h-screen w-screen flex justify-center items-center bg-primary-dark">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <motion.div
            animate={{ opacity: [0.5, 1, 0.5] }}
            transition={{ repeat: Infinity, duration: 2 }}
          >
            <img src={Logo} alt="Logo" className="h-24 w-auto mx-auto mb-4" />
          </motion.div>

          <motion.h1
            className="text-4xl font-bold text-accent-light mb-4"
            animate={{
              opacity: [0.5, 1, 0.5],
              scale: [0.98, 1.02, 0.98],
              rotate: [0, 2, 0, -2, 0],
            }}
            transition={{
              repeat: Infinity,
              duration: 2,
            }}
          >
            ARTE OLIVIERI
          </motion.h1>
          <div className="relative w-64 h-2 bg-primary-light rounded-full overflow-hidden">
            <motion.div
              className="absolute top-0 left-0 h-full bg-accent"
              initial={{ width: 0 }}
              animate={{ width: "100%" }}
              transition={{ duration: 1.8, ease: "easeInOut" }}
            />
          </div>
        </motion.div>
      </div>
    );
  }
  {
    /*Agregar galeria de scroll horizontal, quitar cuentos visuales, libro más pequeño, cambiar imagen hero section*/
  }
  return (
    <PageLayout>
      <HeroSection />
      <PrintsSection />
      <ContextGallery />
      <FeaturedArtwork />
      <ArtistSection />
      <ContactSection />
    </PageLayout>
  );
};

export default App;
